import { render, staticRenderFns } from "./Intern.vue?vue&type=template&id=5bf3fc91&scoped=true&"
import script from "./Intern.ts?vue&type=script&lang=ts&"
export * from "./Intern.ts?vue&type=script&lang=ts&"
import style0 from "./Intern.vue?vue&type=style&index=0&id=5bf3fc91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3fc91",
  null
  
)

export default component.exports
import {QForm,QSelect,QInput,QPopupProxy,QBanner,QDate,QIcon,QToggle,QExpansionItem,QCard,QCardSection,QBtn,QDialog,QField} from 'quasar'
component.options.components = Object.assign({QForm,QSelect,QInput,QPopupProxy,QBanner,QDate,QIcon,QToggle,QExpansionItem,QCard,QCardSection,QBtn,QDialog,QField}, component.options.components || {})
